export default __webpack_public_path__ + "static/5-0a9f7b510ceb7b5e7d7845c0dc1960a6.jpg";